/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Number_Mac_RoomsInputs */



/**
* | output |
* | --- |
* | "Number, MAC, rooms" |
*
* @param {Number_Mac_RoomsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const number_mac_rooms = /** @type {((inputs?: Number_Mac_RoomsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Number_Mac_RoomsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Number, MAC, rooms")
	return /** @type {LocalizedString} */ ("Numéro, MAC, pièces")
});